import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import React from 'react';
import { Button } from 'components/buttons/Button/Button';
import TeamsCards from '../TeamsCards';

const TeamSection = () => (
    <div className="inner-container">
        <div className="main-text-container">
            <LabelButton>Our team</LabelButton>
            <div className="offset-left-4 max-width-760">
                <GradientText size="middle">
                    We’re part of a global movement of people <em>working together to achieve a common goal</em>
                </GradientText>
            </div>
        </div>
        <TeamsCards />
        <Button type="show-more" className="full-width">
            SHOW MORE
        </Button>
    </div>
);

export default TeamSection;
